import gsap from "gsap";

document.addEventListener('DOMContentLoaded', function() {
    const searchTrigger = document.querySelectorAll('.search-trigger');
    const searchContainer = document.querySelector('.search-container');
    const closeSearchBtn = document.querySelector('#closeSearchBtn');

    searchTrigger.forEach(trigger => {
        trigger.addEventListener('click', function() {
            searchContainer.classList.add('active');
            gsap.to(searchContainer, {duration: 0.3, top: 0});
        });
    });

    closeSearchBtn.addEventListener('click', function() {
        searchContainer.classList.remove('active');
        gsap.to(searchContainer, {duration: 0.3, top: '-110%'});
    });
});